import { getJSON } from 'wix-fetch';

export const get_data = async (type,query) => {
    const response = await getJSON(`https://storage.elfsight.com/api/tiktok?type=${type}&query=${query}`);
    return response;
}
export const  overwriteWithMobileValues = (settings)=> {
    settings.desktop = false;
    Object.keys(settings).forEach(key => {
        const mobileKey = `m_${key}`;
        if (settings.hasOwnProperty(mobileKey)) {
            settings[key] = settings[mobileKey];
        }
    });
    return settings;
}

